import { BulkErrorBoundary } from '@components/Alerts/ErrorBoundaryFallback';
import { Header } from '@components/Header/Header';
import dynamic from 'next/dynamic';
import type { FC, ReactNode } from 'react';

const FooterDynamic = dynamic(() =>
  import('../../components/Footer/Footer').then((mod) => mod.Footer)
);

type Props = {
  children: ReactNode;
} & Record<string, any>;

const ProductLayout: FC<Props> = ({ children }) => {
  return (
    <>
      <Header />
      <BulkErrorBoundary location="ProductLayout">{children}</BulkErrorBoundary>
      <FooterDynamic />
    </>
  );
};

export { ProductLayout };
